// src/data/translations.js
export const translations = {
    fr: {
      // Header
      "nav.home": "Accueil",
      "nav.about": "À Propos",
      "nav.skills": "Compétences",
      "nav.projects": "Projets",
      "nav.experience": "Parcours",
      "nav.contact": "Contact",
      "nav.blog": "Blog",
  
      // Hero section
      "hero.title": "Développeur Full Stack",
      "hero.subtitle": "Expert en Spring Boot, React Native, React JS et DevOps",
      "hero.description": "Passionné par le développement de solutions innovantes et performantes.",
      "hero.cta.projects": "Voir mes projets",
      "hero.cta.contact": "Me contacter",
  
      // About section
      "about.title": "À Propos de Moi",
      "about.job": "Développeur Full Stack",
      "about.description1": "Développeur Full Stack passionné, spécialisé en Java et React, avec une solide expérience dans la conception de solutions logicielles innovantes et les tests de logiciels.",
      "about.description2": "Expert en gestion de projets, en méthodologies Agile et en déploiement d'applications (CI/CD), je suis déterminé à relever de nouveaux défis et à transformer vos idées en solutions digitales performantes.",
      "about.techSkills": "Compétences techniques",
      "about.languages": "Langages de programmation",
      "about.frameworks": "Frameworks & Bibliothèques",
      "about.databases": "Bases de données",
      "about.tools": "Outils & Méthodologies",
      "about.education": "Formation",
      "about.downloadCV": "Télécharger mon CV",
      "about.stats.projects": "Projets complétés",
      "about.stats.clients": "Clients satisfaits",
      "about.stats.experience": "Années d'expérience",
      "about.stats.technologies": "Technologies maîtrisées",
      "about.techFavorites": "Technologies favorites",
  
      // Skills section
      "skills.title": "Mes Compétences",
      "skills.backend": "Backend",
      "skills.frontend": "Frontend",
      "skills.devops": "DevOps",
  
      // Projects section
      "projects.title": "Mes Projets",
      "projects.viewDetails": "Voir détails",
      "projects.viewMore": "Voir plus de projets sur GitHub",
      "projects.features": "Fonctionnalités",
      "projects.technologies": "Technologies",
      "projects.sourceCode": "Code source",
      "projects.liveDemo": "Démo en ligne",
      "projects.prevProject": "Projet précédent",
      "projects.nextProject": "Projet suivant",
  
      // Experience section
      "experience.title": "Mon Parcours",
      "experience.downloadCV": "Télécharger mon CV",
  
      // Contact section
      "contact.title": "Me Contacter",
      "contact.subtitle": "Envoyez-moi un message",
      "contact.name": "Nom",
      "contact.email": "Email",
      "contact.subject": "Sujet",
      "contact.message": "Message",
      "contact.sending": "Envoi en cours...",
      "contact.send": "Envoyer",
      "contact.success": "Votre message a bien été envoyé. Je vous répondrai dès que possible.",
      "contact.info": "Informations de contact",
      "contact.phone": "Téléphone",
      "contact.location": "Localisation",
      "contact.followMe": "Retrouvez-moi sur les réseaux sociaux",
  
      // Footer
      "footer.rights": "Tous droits réservés.",
      "footer.madeWith": "Réalisé avec",
      "footer.and": "et",
      "footer.menu": "Menu",
      "footer.services": "Services",
      "footer.webDev": "Développement Web",
      "footer.mobileDev": "Applications Mobiles",
      "footer.apiDev": "API REST",
      "footer.microservices": "Microservices",
      "footer.devops": "DevOps"
    },
    en: {
      // Header
      "nav.home": "Home",
      "nav.about": "About",
      "nav.skills": "Skills",
      "nav.projects": "Projects",
      "nav.experience": "Experience",
      "nav.contact": "Contact",
  
      // Hero section
      "hero.title": "Full Stack Developer",
      "hero.subtitle": "Expert in Spring Boot, React Native, React JS and DevOps",
      "hero.description": "Passionate about developing innovative and high-performance solutions.",
      "hero.cta.projects": "View my projects",
      "hero.cta.contact": "Contact me",
  
      // About section
      "about.title": "About Me",
      "about.job": "Full Stack Developer",
      "about.description1": "Passionate Full Stack Developer, specialized in Java and React, with solid experience in designing innovative software solutions and software testing.",
      "about.description2": "Expert in project management, Agile methodologies, and application deployment (CI/CD), I am determined to take on new challenges and transform your ideas into high-performance digital solutions.",
      "about.techSkills": "Technical skills",
      "about.languages": "Programming languages",
      "about.frameworks": "Frameworks & Libraries",
      "about.databases": "Databases",
      "about.tools": "Tools & Methodologies",
      "about.education": "Education",
      "about.downloadCV": "Download my CV",
      "about.stats.projects": "Completed projects",
      "about.stats.clients": "Satisfied clients",
      "about.stats.experience": "Years of experience",
      "about.stats.technologies": "Technologies mastered",
      "about.techFavorites": "Favorite technologies",
  
      // Skills section
      "skills.title": "My Skills",
      "skills.backend": "Backend",
      "skills.frontend": "Frontend",
      "skills.devops": "DevOps",
  
      // Projects section
      "projects.title": "My Projects",
      "projects.viewDetails": "View details",
      "projects.viewMore": "See more projects on GitHub",
      "projects.features": "Features",
      "projects.technologies": "Technologies",
      "projects.sourceCode": "Source code",
      "projects.liveDemo": "Live demo",
      "projects.prevProject": "Previous project",
      "projects.nextProject": "Next project",
  
      // Experience section
      "experience.title": "My Experience",
      "experience.downloadCV": "Download my CV",
  
      // Contact section
      "contact.title": "Contact Me",
      "contact.subtitle": "Send me a message",
      "contact.name": "Name",
      "contact.email": "Email",
      "contact.subject": "Subject",
      "contact.message": "Message",
      "contact.sending": "Sending...",
      "contact.send": "Send",
      "contact.success": "Your message has been sent successfully. I will get back to you as soon as possible.",
      "contact.info": "Contact information",
      "contact.phone": "Phone",
      "contact.location": "Location",
      "contact.followMe": "Find me on social media",
  
      // Footer
      "footer.rights": "All rights reserved.",
      "footer.madeWith": "Made with",
      "footer.and": "and",
      "footer.menu": "Menu",
      "footer.services": "Services",
      "footer.webDev": "Web Development",
      "footer.mobileDev": "Mobile Applications",
      "footer.apiDev": "REST API",
      "footer.microservices": "Microservices",
      "footer.devops": "DevOps"
    }
  };